export default __webpack_public_path__ + "static/play-online-514e6cb35a7799990cd5d4ef0ee8aabe.png";